import { render, staticRenderFns } from "./AccessGroupsList.vue?vue&type=template&id=36fe8f60&scoped=true"
import script from "./AccessGroupsList.vue?vue&type=script&lang=js"
export * from "./AccessGroupsList.vue?vue&type=script&lang=js"
import style0 from "./AccessGroupsList.vue?vue&type=style&index=0&id=36fe8f60&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe8f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36fe8f60')) {
      api.createRecord('36fe8f60', component.options)
    } else {
      api.reload('36fe8f60', component.options)
    }
    module.hot.accept("./AccessGroupsList.vue?vue&type=template&id=36fe8f60&scoped=true", function () {
      api.rerender('36fe8f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Endpoints/AccessGroupsList.vue"
export default component.exports